<template>
    <div>
        <v-dialog
            v-if="!readonly || !file.isImage"
            v-model="dialog"
            width="unset"
            max-width="1100">
            <template #activator="{ on }">
                <v-card
                    dark
                    class="rounded-lg mr-2 mt-2"
                    height="150"
                    width="150">
                    <v-img
                        v-if="file.isImage"
                        class="thumbnail-image rounded-lg"
                        height="150"
                        max-width="150"
                        :src="imageSource"
                        v-on="on" />
                    <div v-else class="thumbnail-file">
                        <v-icon>
                            mdi-file-document
                        </v-icon>
                        <span class="my-auto mx-4 ">
                            {{ file.name }}
                        </span>
                    </div>
                    <v-btn
                        v-if="!readonly"
                        fab
                        x-small
                        absolute
                        bottom
                        left
                        color="#00000099"
                        class="my-6 no-print"
                        @click="deleteFile(file.id)">
                        <v-icon>
                            mdi-trash-can-outline
                        </v-icon>
                    </v-btn>
                    <v-btn
                        fab
                        x-small
                        absolute
                        bottom
                        right
                        color="#00000099"
                        class="my-6 no-print"
                        @click="downloadFile(file.id, alternateSource)">
                        <v-icon>
                            mdi-download
                        </v-icon>
                    </v-btn>
                </v-card>
            </template>
            <v-card color="white">
                <v-card-title class="image-card-title">
                    <span>{{ file.name }}</span>
                    <v-spacer />
                    <v-btn text @click="dialog = false">
                        Close
                    </v-btn>
                </v-card-title>
                <v-img contain max-height="700" :src="imageSource">
                    <v-btn
                        class="mx-2 my-10"
                        absolute
                        bottom
                        left
                        small
                        fab
                        dark
                        color="#8c8c8c99"
                        @click="deleteFile(file.id)">
                        <v-icon dark color="red">
                            mdi-trash-can-outline
                        </v-icon>
                    </v-btn>
                </v-img>
            </v-card>
        </v-dialog>
        <app-full-image
            v-if="readonly && file.isImage"
            :id="file.id"
            :alternate-source="alternateSource" />
    </div>
</template>

<script>
import { downloadFile } from "@/services/fileService";
import AppFullImage from "@/components/AppFullImage.vue";

export default {
    components: {AppFullImage},
    props: {
        file: {
            type: Object,
            default: null
        },
        readonly: {
            type: Boolean,
            default: false
        },
        alternateSource: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            dialog: false
        }
    },

    computed: {
        imageSource() {
            return this.alternateSource
                ? this.alternateSource+this.file.id
                : '/api/Files/Download/'+this.file.id;
        }
    },

    methods: {
        deleteFile(id) {
            if (!confirm("Are you sure you want to delete this item?")) {
                return;
            }

            this.$emit('delete', id);
            this.dialog = false;
        },
        downloadFile
    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/theme.scss";

.thumbnail-image {
    cursor: pointer;
    border: 0.0625rem solid $color-grey-light;
}

.thumbnail-image:hover {
    -webkit-transform: scale(1.04); // For chrome
    transform: scale(1.04);
}

.thumbnail-file {
    display: flex;
    height: 9.375rem;
    width: 9.375rem;
}

.thumbnail-file > i {
    position: absolute;
    top: 0.75rem;
    width: 100%;
    color: $color-grey-dark;
}

.thumbnail-file > span {
    text-overflow: ellipsis;
    word-wrap: break-word;
    overflow: hidden;
    max-height: 4.5em;
    line-height: 1.5em;
}

.image-card-title {
    background-color: $color-grey-light;
}

.image-card-title > span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 88%;
}
</style>
